module.exports = __webpack_public_path__ + "static/img/charles59_Japanese_young_fashion_model_white_background_bright__c32f9853-a071-4234-aabf-9b6a79d5fb2b.e9787a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/charles59_Japanese_young_fashion_model_white_background_bright__c32f9853-a071-4234-aabf-9b6a79d5fb2b.png
// module id = FhYD
// module chunks = 0